var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pt-30 pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "140px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上级：" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          props: { checkStrictly: true },
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.pid,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pid", $$v)
                          },
                          expression: "form.pid",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "页面标题：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "页面标题:如订单管理" },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "页面名称：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "页面名称:如order[必须唯一]" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "图标：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "左侧图标" },
                        model: {
                          value: _vm.form.icon,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "icon", $$v)
                          },
                          expression: "form.icon",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "url地址：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "页面标题:如home" },
                        model: {
                          value: _vm.form.path,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "path", $$v)
                          },
                          expression: "form.path",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "组件地址：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "页面标题:如/home/home" },
                        model: {
                          value: _vm.form.file_path,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "file_path", $$v)
                          },
                          expression: "form.file_path",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "props参数：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "页面标题:如{user_type: 1}" },
                        model: {
                          value: _vm.form.props,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "props", $$v)
                          },
                          expression: "form.props",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "菜单所属：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.menu_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "menu_type", $$v)
                            },
                            expression: "form.menu_type",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("总后台"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "2" } }, [
                            _vm._v("子后台"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "3" } }, [
                            _vm._v("通用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "1" } }, [
                            _vm._v("有效"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "2" } }, [
                            _vm._v("无效"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "显示：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.hidden,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "hidden", $$v)
                            },
                            expression: "form.hidden",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: 1 } }, [
                            _vm._v("显示"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: 0 } }, [
                            _vm._v("不显示"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }